// DashboardHome.jsx
import './DashboardHome.css';
import DashboardBase  from "../DashboardBase";
import { useAuth } from '../../context/AuthContext';
import AdminHome from './AdminHome';
import CustomerHome from './CustomerHome';
import FundManagerHome from './FundManagerHome';
import { ROLES } from '../../config/routes';

const DashboardHome = () => {
    const { userRole } = useAuth();
    
    return (
        <DashboardBase page="home" content={ 
            userRole === ROLES.FUND_MANAGER ? 
               <FundManagerHome/> : 
            userRole === ROLES.ADMIN ?
               <AdminHome/> 
            : <CustomerHome />
            } />
    );
};

export default DashboardHome;
